import { PureRequestInterceptor } from '../types';
import { HttpHeader } from '../../constants/http';
import { store } from '../../app/store';
import { selectAccessToken } from '../../app/slices/auth.slice';

export const authorize: PureRequestInterceptor = (configuration) => {
	const token = getAuthorizationToken();
	configuration.headers.set(HttpHeader['Authorization'], token);
	return configuration;
};

const getAuthorizationToken = (): string => {
	const state = store.getState();
	const token = selectAccessToken(state);
	if (!token) throw new Error(`Access token not defined inside app store, received: ${token}`);
	return token;
};
